/**
 * Constants for the spinning wheel feature
 */

// Reward symbol constants used across wheel modules
export const REWARD_SYMBOL = {
  USDT: "USDT",
  WETH: "WETH",
  USDC: "USDC",
} as const;

export type RewardSymbol = (typeof REWARD_SYMBOL)[keyof typeof REWARD_SYMBOL];

/**
 * Spin Phase States
 * Defines the different states of the spinning wheel animation
 */
export const WHEEL_SPIN_PHASES = {
  IDLE: "idle",
  INITIAL_SPIN: "initial-spin",
  WAITING_FOR_RESULT: "waiting-for-result",
  LANDING: "landing",
  SHOWING_RESULTS: "showing-results",
} as const;

export type WheelSpinPhase = (typeof WHEEL_SPIN_PHASES)[keyof typeof WHEEL_SPIN_PHASES];

/**
 * Rate limit cooldown in milliseconds (5 seconds)
 */
export const RATE_LIMIT_COOLDOWN_MS = 5_000;

/**
 * Timeout for spin operation in milliseconds (45 seconds)
 */
export const SPIN_TIMEOUT_MS = 45000;

/**
 * Grand Prize reward types (by label)
 * These rewards receive special visual treatment (color, animations, etc.)
 */
export const GRAND_PRIZE_REWARDS_THRESHOLDS: Record<RewardSymbol, number> = {
  [REWARD_SYMBOL.USDT]: 50,
  [REWARD_SYMBOL.WETH]: 1,
  [REWARD_SYMBOL.USDC]: 50,
};

/**
 * Grand prize color for wheel segments and UI
 * References the theme variable for consistency
 */
export const GRAND_PRIZE_COLOR = "var(--color-wheel-grand-prize)";

/**
 * Animation durations in milliseconds
 */
export const ANIMATION_DURATIONS = {
  /** Modal fade in/out */
  MODAL: 300,
  /** Slide animation */
  SLIDE: 400,
  /** Landing animation */
  LANDING: 6000,
  /** Result delay after landing */
  RESULT_DELAY: 200,
} as const;
